<template>
    <div class="ht-tab-wrap">
      <div class="section-title-wrapper text-center section-space--mb_30">
        <h5 class="section-title font-width-light wow move-up">Soin de la peau</h5>
      </div>
        <b-tabs class="ht-tab-menu wow move-up">
            <b-tab title="Cors et callosités" active>
                <!-- tab content one component -->
                <PeauCorsCallosites />
            </b-tab>
            <b-tab title="Verrues plantaires">
                <!-- tab content two component -->
                <PeauVerruesPlantaires />
            </b-tab>
            <b-tab title="Pied d'athlète">
                <!-- tab content third component -->
                <PeauPiedAthlete />
            </b-tab>
            <b-tab title="Transpiration excessive">
              <!-- tab content two component -->
              <PeauTranspiration />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import PeauCorsCallosites from '@/components/pied-pro-custom/soins/peau/PeauCorsCallosites'
    import PeauPiedAthlete from '@/components/pied-pro-custom/soins/peau/PeauPiedAthlete'
    import PeauTranspiration from '@/components/pied-pro-custom/soins/peau/PeauTranspiration'
    import PeauVerruesPlantaires from '@/components/pied-pro-custom/soins/peau/PeauVerruesPlantaires'

    export default {
        name: 'PeauContainer',
        components: {
          PeauCorsCallosites,
          PeauPiedAthlete,
          PeauTranspiration,
          PeauVerruesPlantaires,
        }
    };
</script>